<template>
	<ul>
		<li v-if="!siteSelected && userRoles.includes('users.listAll')">
			<a href="#"><i class="fas fa-fw fa-cog"></i> Settings <i class="fas fa-chevron-right"></i></a>
			<ul>
				<li v-if="userRoles.includes('users.listAll')"><a :href="urls['usersUrl']">Users</a></li>
			</ul>
		</li>
		<li v-if="!siteSelected">
			<a><i class="fas fa-fw fa-users"></i> HR <i class="fas fa-chevron-right"></i></a>
			<ul>
				<li><a v-if="userRoles.includes('hr.create')" :href="urls['hrevents']">Events</a></li>
				<li><a :href="urls['hrdayoffs']">Day Offs</a></li>
			</ul>
		</li>
		<li v-if="!siteSelected && userRoles.includes('audit.view')">
			<a><i class="fas fa-fw fa-file-signature"></i> Audit Logs <i class="fas fa-chevron-right"></i></a>
			<ul>
				<li><a :href="urls['auditLogs']">List Audit logs</a></li>
				<li><a :href="urls['auditLogsByUser']">By Users</a></li>
				<li><a :href="urls['auditLogsByMonths']">By Month</a></li>
			</ul>
		</li>
		<li v-if="siteSelected && userRoles.includes('site_settings.update')">
			<a :href="urls['siteSettingsUrl']"><i class="fas fa-fw fa-cog"></i> Site Settings</a>
		</li>
		<li v-if="siteSelected">
			<a :href="urls['providerTypesUrl']"><i class="fas fa-fw fa-id-card"></i> Providers
				<i class="fas fa-chevron-right"></i></a>
			<ul>
				<li><a :href="urls['providerListerUrl']">List All Providers</a></li>
				<li><a :href="urls['providerTypesUrl']">Manage Provider Types</a></li>
				<li class="has-separator"><a :href="urls['userReviewsUrl']">Manage User reviews</a></li>
				<li v-for="providerType in urls['providerTypes']"><a
						:href="urls['providerTypesUrl'] + '/' + providerType.id + '/edit'">{{ providerType.name }}</a>
				</li>
			</ul>
		</li>
		<li v-if="siteSelected && (userRoles.includes('provider_lists_tables.listAll') || userRoles.includes('coupons.update'))">
			<a href="#"><i class="fas fa-fw fa-handshake"></i> Commercial
				<i class="fas fa-chevron-right"></i></a>
			<ul>
				<li v-if="userRoles.includes('provider_lists_tables.listAll')">
					<a :href="urls['providerListUrl']">Provider Lists</a>
				</li>
				<li v-if="userRoles.includes('coupons.update')">
					<a :href="urls['couponUrl']">Coupon builder</a>
				</li>
				<li v-if="userRoles.includes('loopholes.listAll')">
					<a :href="urls['loopholeUrl']">Loophole builder</a>
				</li>
				<li class="has-separator"><a :href="urls['providerPortalUsersUrl']">Manage Portal Users</a></li>
			</ul>
		</li>
		<li v-if="siteSelected && (userRoles.includes('articles.listAll') || userRoles.includes('categories.listAll') || userRoles.includes('comments.listAll') || userRoles.includes('large_data_tables.listAll'))">
			<a :href="urls['articlesUrl']"><i class="fas fa-fw fa-book-open"></i> Content
				<i class="fas fa-chevron-right"></i></a>
			<ul>
				<li><a :href="urls['articlesUrl']" v-if="userRoles.includes('articles.listAll')">Articles</a></li>
				<li><a :href="urls['categoriesUrl']" v-if="userRoles.includes('categories.listAll')">Categories</a></li>
				<li><a :href="urls['labelsUrl']" v-if="userRoles.includes('articles.listAll')">Labels</a></li>
				<li v-if="userRoles.includes('redirects.listAll')">
					<a :href="urls['redirectsUrl']">Redirects</a>
				</li>
				<li><a :href="urls['seoUrl']">Seo</a></li>
				<li><a :href="urls['commentsUrl']" v-if="userRoles.includes('comments.listAll')">Comments</a></li>
				<li><a :href="urls['countriesHubUrl']" v-if="userRoles.includes('countrieshub.update')">CountriesHub</a>
				</li>
				<li>
					<a :href="urls['largeDataTablesUrl']" v-if="userRoles.includes('large_data_tables.listAll')">LargeDataTables</a>
				</li>
				<li><a :href="urls['chartsUrl']">Charts</a></li>
			</ul>
		</li>
		<li v-if="siteSelected">
			<a :href="urls['toolsHubUrl']"><i class="fas fa-fw fa-tools"></i> ToolsHub<i class="fas fa-chevron-right"></i></a>
			<ul>
				<li v-for="item in urls.subMenus.ToolsHub"><a :href="item.editUrl">{{ item.name }}</a></li>
			</ul>
		</li>
		<li v-if="siteSelected && userRoles.includes('staticpage.update')">
			<a :href="urls['staticPagesUrl']"><i class="fas fa-fw fa-tools"></i> Static Pages
				<i class="fas fa-chevron-right"></i></a>
			<ul>
				<li v-for="item in urls.subMenus.StaticPages"><a :href="item.editUrl">{{ item.name }}</a></li>
			</ul>
		</li>
		<li v-if="siteSelected && (userRoles.includes('languages.listAll') || userRoles.includes('site_content.listAll'))">
			<a href="#"><i class="fas fa-fw fa-language"></i> Languages <i class="fas fa-chevron-right"></i></a>
			<ul>
				<li v-if="userRoles.includes('languages.listAll')"><a :href="urls['languagesUrl']">Languages</a></li>
				<li v-if="userRoles.includes('site_content.listAll')">
					<a :href="urls['translationsUrl']">Translations</a>
				</li>
			</ul>
		</li>
		<li v-if="siteSelected">
			<a href="/writers-guide"><i class="fas fa-fw fa-pen-nib"></i> Writers' Guide</a>
		</li>
	</ul>
</template>

<script>
export default {
	props: {
		dataCurrentUrl: {
			type: String
		},
		dataUrls: {
			type: Object
		},
		dataUserRoles: {
			type: Array
		}
	},
	data() {
		return {
			currentUrl: this.dataCurrentUrl,
			urls: this.dataUrls,
			userRoles: this.dataUserRoles,

			siteSelected: Object.keys(this.$selectedSite).length !== 0
		}
	},
	methods: {
		findBaseUrl: function (str) {
			let delimiter = '/';
			let parts = str.split(delimiter).slice(0, 3);
			return parts.join(delimiter);
		}
	}
}
</script>

<style scoped>

</style>
